import React from 'react';

export default () => (
  <div className="text-center text-gray-500 text-xs w-full border-t border-gray-400">&copy; 2020 Liven Pty Ltd. All rights reserved.</div>
);
